import DeleteFixture from "./DeleteFixture";
export default DeleteFixture;
